<template>
  <v-card width="100%">
    <v-card-title class="align-start pb-0">
      <v-icon class="mr-5">
        {{ icons.mdiCashRegister }}
      </v-icon>
      Estado de Cuenta
      <v-spacer></v-spacer>
      <payment-status
        :status="booking.payStatusId"
        :size="parseInt('43')"
      />
    </v-card-title>

    <v-card-text class="d-flex align-center justify-space-between pt-0">
      <div>
        <v-row>
          <price-label
            title="Total Cargos"
            :text="price"
            css-style="font-size:20px; font-weight: bold;"
          />
          <price-label
            title="Total Pagos"
            :text="paid"
            css-style="font-size:20px; font-weight: bold;"
          />
          <price-label
            title="Sesión"
            :text="booking.price"
          />
          <price-label
            title="Pagos"
            :text="booking.paid"
          />
          <price-label
            title="Promo"
            :text="promo"
            :subtitle=" booking.promo"
          />
          <price-label
            title="Rembolsos"
            :text="booking.refunded"
          />
          <price-label
            title="AddOns"
            :text="booking.addOns"
          />
          <v-col
            cols="12"
            sm="6"
            class="py-0"
          >
          </v-col>
          <price-label
            title="Por Pagar"
            :text="toPay"
            css-style="font-size:20px; font-weight: bold;"
          />
        </v-row>
      </div>

      <div class="chart-wrapper">
        <vue-apex-charts
          :options="chartOptions"
          :series="randomSeries"
        ></vue-apex-charts>
      </div>
    </v-card-text>
    <v-card-text class="mt-2">
      <resume-list :list="list" />
    </v-card-text>
  </v-card>
</template>

<script>
import {
  ref, onMounted, computed,
} from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'
import { mdiCashRegister } from '@mdi/js'
import useStaticResumeChartOptions from '@/views/payments/scripts/resumeChartOptions'
import getPaymentsList from '@/components/lists/payments'
import ResumeList from '@/views/payments/components/ResumeList.vue'
import PaymentStatus from '@/components/statusIcon/PaymentStatus.vue'
import Calculations from '@/scripts/helpers/calculations'
import PriceLabel from '@/views/payments/components/PriceLabel.vue'

export default {
  components: {
    VueApexCharts,
    ResumeList,
    PaymentStatus,
    PriceLabel,
  },
  props:
  {
    booking: {
      type: Object,
      required: true,
    },

  },
  setup(props) {
    const { chartOptions, randomSeries } = useStaticResumeChartOptions('Primary')
    const list = ref([])

    const {
      TotalPrice, TotalPaid, ToPay, TotalPromo,
    } = Calculations()
    const paid = computed(() => TotalPaid(props.booking))
    const toPay = computed(() => ToPay(props.booking))
    const price = computed(() => TotalPrice(props.booking))
    const promo = computed(() => TotalPromo(props.booking))

    const refresh = () => {
      getPaymentsList(props.booking.bookingKey)
        .then(data => {
          list.value = data
        })
    }

    onMounted(refresh)

    return {
      chartOptions,
      randomSeries,
      refresh,
      list,
      paid,
      toPay,
      price,
      promo,
      icons: {
        mdiCashRegister,
      },
    }
  },
}
</script>

  <style lang="scss" scoped>
  .chart-wrapper {
  max-width: 130px;
}
  .statistics-table {
    border-top: solid 1px rgba(93, 89, 98, 0.14);
    .badge-sm {
      width: 0.875rem;
      height: 0.875rem;
      border-radius: 50%;
      margin: 4px;
    }
  }
  </style>
